import React from 'react';

import Button from '@atlaskit/button';

import URLService from '@qality/cloud-services/src/URLService';

import {
  ContainerStyled,
  TextStyled,
  TitleStyled,
} from './TestCaseRepositoryFoldersBenefits.styled';

const openDocumentation = () => {
  window.open(URLService.getQalityVersionsComparisonUrl(), '_blank');
};

export function TestCaseRepositoryFoldersBenefits(): JSX.Element {
  return (
    <ContainerStyled>
      <TitleStyled>
        In QAlity Plus you can organize your Test Cases in folders
      </TitleStyled>
      <TextStyled>
        QAlity Plus introduces folders as a new way of organizing test cases.
        What’s more, it enables creating Test Cycles based on Test Cases stored
        in folders. Upgrade to QAlity Plus to organize your tests base!
      </TextStyled>
      <Button
        appearance='primary'
        onClick={openDocumentation}
        style={{ alignSelf: 'start' }}
      >
        Learn more about QAlity Plus
      </Button>
    </ContainerStyled>
  );
}
